import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import fileDownload from 'js-file-download';
import { getInfo, wrapperCall } from './utils';

async function handlePrint(event, params, token, navigate) {
    event.preventDefault(); 
    const info = getInfo();
    const rowData = params.node.data; 

    const data = {
        companyName: rowData.CompanyName,
        docType: rowData.DocumentType,
        docNo: rowData.DocumentNo,
        outputFormat: info.outputFormat
    }

    const response = await wrapperCall('printDocument', data, token, 'blob', navigate);
    const filename = response.headers['file-name'];
    fileDownload(response.data, filename);
}

const CustomAnchorComponentPrint = (params) => {
    const token = useSelector(state => state.auth.token);
    const navigate = useNavigate();

    return (
        <a
            href="#"
            onClick={(event) => handlePrint(event, params, token, navigate)} 
        >
            Print
        </a>
    );
};

const CustomAnchorComponentDetail = (params) => {
    const rowData = params.node['data'];
    const url = `/detail/${rowData['_interface']}/${rowData['DocumentNo']}/${rowData['DocumentType']}/${rowData['CompanyName']}`;

    return (
        <a
            href={url}
            target="_blank"
        >
            Details
        </a>
    );
};

const openEntriesColumn = [
    { field: "CompanyName", filter: true },
    { field: "DocumentDate", filter: "agDateColumnFilter" },
    { field: "DocumentType", filter: true },
    { field: "DocumentNo", filter: true },
    { field: "ExternalDocNo", filter: true },
    { field: "Reference", filter: true },
    { field: "ChargeType", filter: true },
    { field: "Currency", filter: true },
    { field: "OriginalAmount", filter: "agNumberColumnFilter" },
    { field: "OriginalVATAmount", filter: "agNumberColumnFilter" },
    { field: "RemaningAmount", filter: "agNumberColumnFilter" },
    { field: "interface", hide: true },
    { field: "PrintDocument", cellRenderer: CustomAnchorComponentPrint },
    { field: "Details", cellRenderer: CustomAnchorComponentDetail }
]

export default openEntriesColumn;